module.exports = __webpack_public_path__ + "img/16581272_L.4a9da4c7.png";